import React, { HTMLAttributeAnchorTarget, ReactNode } from "react";
import classNames from "classnames";

import { BaseProps } from "@src/types/BaseProps.types";

import "./ContactLink.scss";

interface ContactLinkProps extends BaseProps<HTMLAnchorElement> {
  title?: string;
  href: string;
  target?: HTMLAttributeAnchorTarget;
  follow?: boolean;
  download?: string;
  disabled?: boolean;
  uppercase?: boolean;
  className?: string;
  children: ReactNode;
}

const ContactLink = ({
  title,
  href,
  target = "_self",
  follow = false,
  download,
  disabled = false,
  uppercase = true,
  className = "",
  children,
  ...props
}: ContactLinkProps) => {
  const rel = follow ? "dofollow" : `noopener noreferrer nofollow`;
  const classes = classNames(`contact-link`, { disabled: disabled, uppercase: uppercase }, className);

  return (
    <a href={href} target={target} rel={rel} title={title} className={classes} download={download} {...props}>
      {children}
    </a>
  );
};

export default ContactLink;
